import { Injectable } from '@angular/core';
import { DateAgoPipe } from '@dp/pipes/date-ago/date-ago.pipe';
import { UDS_ICON_MAP } from 'app/image.constants';
import { SvgMap } from 'app/shared/components/svg/uds-svg-map';
import { MapSpace } from 'app/shipments2/shipments3.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ShipmentMapService {
  CDN_BASE_URL = environment.cdnAssetsBasePath;
  mapSvg = {
    MAP_DESTINATION: UDS_ICON_MAP.milestone,
    MAP_ORIGIN: `${this.CDN_BASE_URL}svg/map/map-origin.ods.svg`,
    MAP_PORT: `${this.CDN_BASE_URL}svg/map/map-port.ods.svg`,
    MAP_VESSEL: UDS_ICON_MAP.vessel,
  };
  stopSmall = {
    scaledSize: {
      width: 14,
      height: 14,
    },
    anchor: {
      x: 7,
      y: 7,
    },
  };
  stopSmallest = {
    scaledSize: {
      width: 2,
      height: 2,
    },
    anchor: {
      x: 1,
      y: 1,
    },
  };
  stopLarge = {
    scaledSize: {
      width: 20,
      height: 20,
    },
    anchor: {
      x: 10,
      y: 10,
    },
  };
  stopSmallComplete = {
    url: 'assets/svg/cityMarkerComplete.svg',
    ...this.stopSmall,
  };
  stopSmallIncomplete = {
    url: 'assets/svg/cityMarkerIncomplete.svg',
    ...this.stopSmall,
  };
  stopLargeComplete = {
    url: 'assets/svg/cityMarkerComplete.svg',
    ...this.stopLarge,
  };
  stopLargeIncomplete = {
    url: 'assets/svg/cityMarkerIncomplete.svg',
    ...this.stopLarge,
  };
  stopCurrent = {
    url: 'assets/svg/cityMarkerCurrent.svg',
    ...this.stopLarge,
  };
  currentLocation = {
    url: 'assets/svg/currentLocation.svg',
    ...this.stopLarge,
  };
  missingPath = {
    url: 'assets/svg/circle_missing.svg',
    ...this.stopSmallest,
  };

  constructor(private dateAgoPipe: DateAgoPipe) {}

  getStopIcon(journeyStop: MapSpace.JourneyStop) {
    const importantStops = [
      MapSpace.SHIPMENT_LOCATION_TYPES.ORIGIN,
      MapSpace.SHIPMENT_LOCATION_TYPES.ORIGIN_PORT,
      MapSpace.SHIPMENT_LOCATION_TYPES.DESTINATION,
      MapSpace.SHIPMENT_LOCATION_TYPES.DESTINATION_PORT,
    ];
    const important = importantStops.includes(journeyStop.type);
    return journeyStop.isFuture
      ? important
        ? this.stopLargeIncomplete
        : this.stopSmallIncomplete
      : important
      ? this.stopLargeComplete
      : this.stopSmallComplete;
  }

  getLabelIcon(stop: MapSpace.JourneyStop, trackingType: string, shipmentType?: string): string {
    return stop.type === MapSpace.SHIPMENT_LOCATION_TYPES.ORIGIN
      ? this.mapSvg.MAP_ORIGIN
      : stop.type === MapSpace.SHIPMENT_LOCATION_TYPES.DESTINATION
      ? this.mapSvg.MAP_DESTINATION
      : trackingType?.toLowerCase() === 'awb_number' || shipmentType === 'AIR_SHIPMENT'
      ? SvgMap.airFreight
      : this.mapSvg.MAP_PORT;
  }

  getCurrentLabelIcon(locationType) {
    return locationType === MapSpace.ShipmentLocationTypes.IN_PORT ? this.mapSvg.MAP_PORT : this.mapSvg.MAP_VESSEL;
  }

  getLocationLabel(locationLabel: string, locationTimestamp: string) {
    let label = '';
    if (locationLabel) {
      label += locationLabel;
    }

    if (locationTimestamp) {
      label += ' (Last updated: ' + this.dateAgoPipe.transform(locationTimestamp) + ')';
    }
    return label;
  }
}
